export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06]">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-accent-500/30 via-transparent to-transparent"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-white mb-4">
                移动观影
              </h2>
              <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-6 max-w-lg">
                51影视全面支持手机、平板等移动设备，无需下载安装，打开浏览器即可享受<strong className="text-white">高清不卡顿</strong>的流畅观影体验。通勤路上、午休时间、睡前追剧，随时随地免费看全集。
              </p>
              <div className="flex flex-wrap gap-3 justify-center lg:justify-start">
                {['全设备兼容', '无需下载', '流量优化', '离线缓存'].map((f) => (
                  <span key={f} className="px-3 py-1.5 text-xs font-medium bg-white/10 text-white/80 rounded-full border border-white/15">
                    {f}
                  </span>
                ))}
              </div>
              <div className="mt-8">
                <a
                  href="#hero"
                  className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer no-underline text-sm"
                >
                  <i className="ri-smartphone-line text-lg"></i>
                  手机立即体验
                </a>
              </div>
            </div>

            <div className="flex-1 w-full flex justify-center">
              <div className="relative">
                <div className="w-64 md:w-72 aspect-[9/16] rounded-3xl overflow-hidden border-4 border-white/20">
                  <img
                    src="https://readdy.ai/api/search-image?query=Mobile%20phone%20mockup%20showing%20movie%20streaming%20app%20interface%20with%20film%20posters%20and%20play%20button%2C%20dark%20theme%20UI%20with%20warm%20accent%20colors%2C%20clean%20modern%20design%20showing%20movie%20thumbnails%20grid%2C%20premium%20streaming%20app%20screenshot%2C%20smartphone%20displaying%20video%20content%20browser&width=500&height=889&seq=app-mockup-51movie&orientation=portrait"
                    alt="51影视移动端观影体验"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute -top-3 -right-3 w-12 h-12 rounded-full bg-accent-500 flex items-center justify-center">
                  <i className="ri-play-fill text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}